const { Component, render, findDOMNode, Fragment } = wp.element;

const $ = jQuery;
const {
  RangeControl,
  CheckboxControl
} = wp.components;

//import ReactPaginate from 'react-paginate';
//import md5 from 'js-md5';

/*import { AZON_Country_Dropdown } from './country-dropdown.class.js';
import {
  WooZoneNoAWSCategs as AzonCategs,
  WooZoneNoAWS_Country_List as Country_List,
  WooZoneNoAWS_isset as isset,
  WooZoneParser,
  WooZoneMakeID as makeid,
  WooZoneChunk as chunk,
  WooZoneHumanFileSize as humanFileSize,
  WooZoneGetDomain as getDomain,
  WooZoneContentTrimmer as contentTrimmer
} from "./amz.utils.js";*/

const alias = 'WooZone-SyncWidget-'
const image_block_wrapper = document.getElementById( `${alias}wrapper` );

class WooZoneNoAWS_SyncWidget extends Component {

  constructor(props) {
    super(props);

    this.DEBUG = true;

    this.state = {
      show_log: true,
    }
  }


  componentDidMount()
  {
    const self = this;
  }

  render()
  {
    const { show_log } = this.state;

    return <Fragment>

      <div>gimi is here</div>

    </Fragment>
  }
}

wp.domReady( function() {
  if( image_block_wrapper ) render( <WooZoneNoAWS_SyncWidget />, image_block_wrapper );
} );



// WEBPACK FOOTER //
// ./src/app.jsx